export default "__VITE_ASSET__C6ZpCUNB__"